import { string } from "prop-types";

import styled from "styled-components";

import FnrContainedIcon from "UI/FnrContainedIcon";

const InactiveState = ({ color }) => {
  return (
    <SFnrContainedIcon color={color} size="lg" icon="fa-comments-alt fas" />
  );
};

const SFnrContainedIcon = styled(FnrContainedIcon)`
  width: 40px;
`;

InactiveState.propTypes = { color: string };

export default InactiveState;
